import AgencyDoctorSelectBox from 'components/molecules/agency-doctor-select-box';
import { Roles, LoginStatus } from 'infrastructure/enums';

import type { IBaseSelectBoxOption } from 'components/atoms/base-select-box/types';
import type { PreparedSelectCareManagersItems } from 'infrastructure/hooks/clinic/use-clinic-care-managers-select-box';

interface Props {
  defaultValue: any[];
  onSelect: (
    val: string,
    options: IBaseSelectBoxOption<PreparedSelectCareManagersItems, any>,
  ) => void;
  onDeselect: (
    val: string,
    options: IBaseSelectBoxOption<PreparedSelectCareManagersItems, any>,
  ) => void;
  agencyGuid: string;
}
export const CareManagersDropdown = ({
  defaultValue,
  onSelect,
  onDeselect,
  agencyGuid,
}: Props) => {
  return (
    <AgencyDoctorSelectBox
      defaultValue={defaultValue}
      onSelect={onSelect}
      onDeselect={onDeselect}
      agencyGuid={agencyGuid}
      roles={[
        Roles.PhysicianAssistant,
        Roles.QHCP,
        Roles.RegisteredNurse,
        Roles.MedicalAssistant,
        Roles.NursePractitioner,
        Roles.Doctor,
      ]}
      onlyCurrentAgency
      status={[LoginStatus.Active]}
      mode="multiple"
    />
  );
};
